import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import './custom.scss';
import 'font-awesome/css/font-awesome.min.css';
import App from './App.jsx';
import * as serviceWorker from './serviceWorker';
import { ThemeProvider } from 'react-jss';
import { HashRouter as Router } from 'react-router-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import compose from 'recompose/compose';
import thunk from 'redux-thunk';
import api from './api';
import { createBreakpoints } from './shared/utils';
import reducer from './ducks';
import { initialAppData } from './ducks/app';

const theme = {
  colors: {
    main: '#3069B2',
    white: '#FFF',
    black: '#000',
    gray: '#dee2e6', // #1D202A 50%
    blue: '#3069B2',
    error: '#dc3545',
    info: '#17a2b8',
    primary: '#004a8c',
    secondary: '#6c757d',
    danger: '#dc3545',
    warning: '#ffc107',
    success: '#3069B2',
    light: '#f8f9fa'
  },
  inputError: {
    borderColor: '#dc3545 !important',
    outline: 0,
    boxShadow: '0 0 0 0.2rem rgba(220,53,69,.25) !important'
  },
  errorMessage: {
    position: 'absolute',
    bottom: -8,
    left: 11,
    backgroundColor: 'white',
    padding: [0, 7],
    fontSize: 11,
    color: '#dc3545',
    zIndex: 3
  },
  bp: createBreakpoints(),
  fonts: {}
};

const composed = window.__REDUX_DEVTOOLS_EXTENSION__
  ? compose(applyMiddleware(thunk.withExtraArgument(api)), window.__REDUX_DEVTOOLS_EXTENSION__())
  : applyMiddleware(thunk.withExtraArgument(api));

const store = createStore(reducer, composed);
store.dispatch(initialAppData());

/* eslint-disable */
ReactDOM.render(
  <Provider store={store}>
    <Router>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Router>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
